import TrainerView from '@/domain/Trainer';
import client from '@/api/client';
import { trainerQuery, trainerSlugsQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: trainerQuery,
    variables: {
      id: params.slug,
    },
  });

  return {
    props: {
      trainer: data?.trainer,
    },
  };
}

export async function getStaticPaths() {
  const { data } = await client().query({ query: trainerSlugsQuery });

  const paths = data?.trainers?.nodes?.map(({ slug }) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: false,
  };
}

export default function Trainer({ trainer }) {
  return <TrainerView trainer={trainer} />;
}
